import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { buildAWSResourceColumns } from './columns';
import { getAWSResourceFields } from './fields';
import { getAWSResourceSimpleFilters } from './simpleFilters';

/**
 * AWSResource QueryEntity - bundles columns and fields
 */
export const awsResourceEntity: QueryEntity<unknown> = {
  primaryLabel: { actual: 'AWSResource', display: 'AWS' },
  buildColumns:
    buildAWSResourceColumns as () => import('@/components/table/types').Columns<unknown>,
  getFields: getAWSResourceFields,
  getSimpleFilters: getAWSResourceSimpleFilters,
};
